export const codingTranslations = {
  fr: {
    title: "Assistant de codage médical",
    titleShort: "Codage",
    backToDashboard: "Retour au tableau de bord",
    backShort: "Retour",
    home: "Accueil",
    description: "Obtenez des suggestions de codes CCAM et CIM-10 à partir de descriptions cliniques",
    hero: {
      title: "Assistant de Codage Médical",
      description: "Générez automatiquement des codes CCAM, CIM-10 et NGAP à partir de descriptions cliniques"
    },
    tabs: {
      assistant: "Assistant",
      history: "Historique",
      favorites: "Favoris"
    },
    favorites: {
      title: "Codes favoris",
      empty: "Aucun code en favori",
      emptyDescription: "Utilisez le bouton cœur pour ajouter des codes",
      addedOn: "Ajouté le",
      buttonSearch: "Parcourir les codes",
      searchFavorites: "Rechercher dans les favoris...",
      removeFromFavorites: "Retirer des favoris",
      remove: "Retirer",
      addedToast: "Code ajouté aux favoris",
      removedToast: "Code retiré des favoris",
      noMatchFilter: "Aucun favori ne correspond à ce filtre",
    },
    history: {
      title: "Historique des recherches",
      empty: "Aucune recherche récente",
      noResults: "Aucun résultat trouvé",
      clear: "Vider l'historique",
      filter: "Filtrer l'historique...",
      emptyDescription: "Vos recherches apparaîtront ici",
      buttonSearch: "Faire une recherche",
      removeFromHistory: "Supprimer de l'historique",
      clearedToast: "Historique vidé",
      clearConfirmTitle: "Vider l'historique ?",
      clearConfirmDesc: "Cette action supprimera définitivement les {{count}} recherche(s) de votre historique. Cette action est irréversible.",
      noMatchFilter: "Aucune recherche ne correspond à \"{{filter}}\"",
    },
    interface: {
      clinicalDescription: "Description clinique",
      placeholder: "Décrivez l'acte médical, le diagnostic ou la pathologie (ex: 'appendicectomie par laparoscopie', 'diabète type 2', 'consultation cardiologique')...",
      generating: "Génération en cours...",
      generateButton: "Générer les codes",
      results: "Résultats de codage",
      codeCopied: "Code copié dans le presse-papiers",
      copyError: "Erreur lors de la copie",
      clickToEdit: "Cliquer pour modifier la description",
      shortcutHint: "⌘/Ctrl + Entrée pour générer",
      retry: "Réessayer",
      backToTop: "Retour en haut",
    },
    sections: {
      resultsNav: "Sections de résultats",
      ccam: "Codes CCAM (Actes médicaux)",
      cim10: "Codes CIM-10 (Diagnostics)",
      ngap: "Codes NGAP",
      ccmu: "Score CCMU",
      valorisation: "Valorisation",
      confiance: {
        faible: "Confiance faible",
        moyenne: "Confiance moyenne",
        haute: "Confiance haute"
      },
      detailPoste: "Détail par poste",
      hypothesesGenerales: "Hypothèses générales",
      totalEstime: "Total estimé",
      justification: "Justification",
      facturation: "Facturation et valorisation",
      consultation: "Consultation",
      ghs: "GHS/Hospitalisation",
      consultationItems: "Éléments de valorisation",
      diagnosticPrincipal: "Diagnostic principal (DP)",
      diagnosticsAssocies: "Diagnostics associés (DR)",
      composants: "Composants de valorisation",
      dureeSejour: "Durée de séjour",
      present: "Présent",
      absent: "Absent",
      commentairesOptimisation: "Commentaires d'optimisation"
    },
    messages: {
      invalidInput: "Veuillez saisir une description clinique",
      success: "Codes générés avec succès",
      noSuggestions: "Aucun code trouvé pour cette description",
      error: "Erreur lors de la génération des codes",
      serverError: "Erreur serveur",
      codesFound: "{{count}} codes suggérés",
      fromCache: "depuis le cache",
      unknownError: "Erreur inconnue",
    },
    feedback: {
      question: "Ces résultats sont-ils utiles ?",
      positive: "Merci pour votre retour positif !",
      negative: "Merci, nous améliorons nos suggestions.",
    },
    export: {
      title: "Résultats de codage médical",
      copied: "Résultats copiés dans le presse-papiers",
      copyError: "Erreur lors de la copie",
    },
    errors: {
      title: "Erreur de génération"
    },
    skeleton: {
      analyzeContext: 'Analyse du contexte clinique',
      generateCCAM: 'Génération codes CCAM',
      generateCIM10: 'Génération codes CIM-10',
      calculateBilling: 'Calcul facturation & valorisation',
      generating: 'Génération en cours…',
      inProgress: 'En cours…',
    },
    time: {
      justNow: "À l'instant",
      minutesAgo: "Il y a {{count}} min",
      hoursAgo: "Il y a {{count}}h",
      daysAgo: "Il y a {{count}} jour(s)",
    },
    dateGroups: {
      today: "Aujourd'hui",
      yesterday: "Hier",
      thisWeek: "Cette semaine",
      older: "Plus ancien",
    },
    enhanced: {
      replayFromHistory: "Relance depuis l'historique",
      aiDisclaimer: "Les codes CCAM sont générés par intelligence artificielle et doivent être vérifiés dans le référentiel officiel ATIH/HAS avant toute utilisation en facturation.",
      clearFilter: "Effacer le filtre",
      resetFilters: "Réinitialiser les filtres",
    },
    examples: {
      appendectomy: "Appendicectomie laparoscopique",
      diabetesFollowup: "Suivi diabète type 2 avec complications",
      hipFracture: "Fracture du col du fémur, personne âgée",
      centralCatheter: "Pose de cathéter veineux central",
      cesarean: "Césarienne programmée",
      endoscopy: "Endoscopie digestive haute diagnostique",
    },
  },
  en: {
    title: "Medical coding assistant",
    titleShort: "Coding",
    backToDashboard: "Back to dashboard",
    backShort: "Back",
    home: "Home",
    description: "Get CCAM and ICD-10 code suggestions from clinical descriptions",
    hero: {
      title: "Medical Coding Assistant",
      description: "Automatically generate CCAM, ICD-10 and NGAP codes from clinical descriptions"
    },
    tabs: {
      assistant: "Assistant",
      history: "History",
      favorites: "Favorites"
    },
    history: {
      title: "Search history",
      empty: "No recent searches",
      noResults: "No results found",
      clear: "Clear history",
      filter: "Filter history...",
      emptyDescription: "Your searches will appear here",
      buttonSearch: "Make a search",
      removeFromHistory: "Remove from history",
      clearedToast: "History cleared",
      clearConfirmTitle: "Clear history?",
      clearConfirmDesc: "This will permanently delete {{count}} search(es) from your history. This action is irreversible.",
      noMatchFilter: "No search matches \"{{filter}}\"",
    },
    favorites: {
      title: "Favorite codes",
      empty: "No favorite codes",
      emptyDescription: "Use the heart button to add codes",
      addedOn: "Added on",
      buttonSearch: "Browse codes",
      searchFavorites: "Search favorites...",
      removeFromFavorites: "Remove from favorites",
      remove: "Remove",
      addedToast: "Code added to favorites",
      removedToast: "Code removed from favorites",
      noMatchFilter: "No favorite matches this filter",
    },
    interface: {
      clinicalDescription: "Clinical description",
      placeholder: "Describe the medical procedure, diagnosis or pathology (e.g: 'laparoscopic appendectomy', 'type 2 diabetes', 'cardiology consultation')...",
      generating: "Generating...",
      generateButton: "Generate codes",
      results: "Coding results",
      codeCopied: "Code copied to clipboard",
      copyError: "Error copying code",
      clickToEdit: "Click to edit description",
      shortcutHint: "⌘/Ctrl + Enter to generate",
      retry: "Retry",
      backToTop: "Back to top",
    },
    sections: {
      resultsNav: "Results sections",
      ccam: "CCAM Codes (Medical procedures)",
      cim10: "ICD-10 Codes (Diagnoses)",
      ngap: "NGAP Codes",
      ccmu: "CCMU Score",
      valorisation: "Valorization",
      confiance: {
        faible: "Low confidence",
        moyenne: "Medium confidence",
        haute: "High confidence"
      },
      detailPoste: "Detail by category",
      hypothesesGenerales: "General assumptions",
      totalEstime: "Estimated total",
      justification: "Justification",
      facturation: "Billing and valorization",
      consultation: "Consultation",
      ghs: "GHS/Hospitalization",
      consultationItems: "Valorization elements",
      diagnosticPrincipal: "Principal diagnosis (DP)",
      diagnosticsAssocies: "Associated diagnoses (DR)",
      composants: "Valorization components",
      dureeSejour: "Length of stay",
      present: "Present",
      absent: "Absent",
      commentairesOptimisation: "Optimization comments"
    },
    messages: {
      invalidInput: "Please enter a clinical description",
      success: "Codes generated successfully",
      noSuggestions: "No codes found for this description",
      error: "Error generating codes",
      serverError: "Server error",
      codesFound: "{{count}} codes suggested",
      fromCache: "from cache",
      unknownError: "Unknown error",
    },
    feedback: {
      question: "Are these results helpful?",
      positive: "Thank you for your positive feedback!",
      negative: "Thank you, we are improving our suggestions.",
    },
    export: {
      title: "Medical coding results",
      copied: "Results copied to clipboard",
      copyError: "Error copying results",
    },
    errors: {
      title: "Generation error"
    },
    skeleton: {
      analyzeContext: 'Analyzing clinical context',
      generateCCAM: 'Generating CCAM codes',
      generateCIM10: 'Generating ICD-10 codes',
      calculateBilling: 'Calculating billing & valuation',
      generating: 'Generating…',
      inProgress: 'In progress…',
    },
    time: {
      justNow: "Just now",
      minutesAgo: "{{count}} min ago",
      hoursAgo: "{{count}}h ago",
      daysAgo: "{{count}} day(s) ago",
    },
    dateGroups: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This week",
      older: "Older",
    },
    enhanced: {
      replayFromHistory: "Replay from history",
      aiDisclaimer: "CCAM codes are generated by artificial intelligence and must be verified in the official ATIH/HAS repository before any billing use.",
      clearFilter: "Clear filter",
      resetFilters: "Reset filters",
    },
    examples: {
      appendectomy: "Laparoscopic appendectomy",
      diabetesFollowup: "Type 2 diabetes follow-up with complications",
      hipFracture: "Hip fracture, elderly patient",
      centralCatheter: "Central venous catheter placement",
      cesarean: "Scheduled cesarean section",
      endoscopy: "Upper GI diagnostic endoscopy",
    },
  },
  es: {
    title: "Asistente de codificación médica",
    titleShort: "Codificación",
    backToDashboard: "Volver al panel",
    backShort: "Volver",
    home: "Inicio",
    description: "Obtenga sugerencias de códigos CCAM e CIE-10 a partir de descripciones clínicas",
    hero: {
      title: "Asistente de Codificación Médica",
      description: "Genere automáticamente códigos CCAM, CIE-10 y NGAP a partir de descripciones clínicas"
    },
    tabs: {
      assistant: "Asistente",
      history: "Historial",
      favorites: "Favoritos"
    },
    history: {
      title: "Historial de búsquedas",
      empty: "Sin búsquedas recientes",
      noResults: "No se encontraron resultados",
      clear: "Vaciar historial",
      filter: "Filtrar historial...",
      emptyDescription: "Sus búsquedas aparecerán aquí",
      buttonSearch: "Hacer una búsqueda",
      removeFromHistory: "Eliminar del historial",
      clearedToast: "Historial vaciado",
      clearConfirmTitle: "¿Vaciar historial?",
      clearConfirmDesc: "Esta acción eliminará permanentemente las {{count}} búsqueda(s) de su historial. Esta acción es irreversible.",
      noMatchFilter: "Ninguna búsqueda coincide con \"{{filter}}\"",
    },
    favorites: {
      title: "Códigos favoritos",
      empty: "Sin códigos favoritos",
      emptyDescription: "Use el botón de corazón para agregar códigos",
      addedOn: "Agregado el",
      buttonSearch: "Explorar códigos",
      searchFavorites: "Buscar en favoritos...",
      removeFromFavorites: "Quitar de favoritos",
      remove: "Quitar",
      addedToast: "Código agregado a favoritos",
      removedToast: "Código eliminado de favoritos",
      noMatchFilter: "Ningún favorito coincide con este filtro",
    },
    interface: {
      clinicalDescription: "Descripción clínica",
      placeholder: "Describa el procedimiento médico, diagnóstico o patología (ej: 'apendicectomía laparoscópica', 'diabetes tipo 2', 'consulta cardiológica')...",
      generating: "Generando...",
      generateButton: "Generar códigos",
      results: "Resultados de codificación",
      codeCopied: "Código copiado al portapapeles",
      copyError: "Error al copiar código",
      clickToEdit: "Clic para editar la descripción",
      shortcutHint: "⌘/Ctrl + Enter para generar",
      retry: "Reintentar",
      backToTop: "Volver arriba",
    },
    sections: {
      resultsNav: "Secciones de resultados",
      ccam: "Códigos CCAM (Procedimientos médicos)",
      cim10: "Códigos CIE-10 (Diagnósticos)",
      ngap: "Códigos NGAP",
      ccmu: "Score CCMU",
      valorisation: "Valorización",
      confiance: {
        faible: "Confianza baja",
        moyenne: "Confianza media",
        haute: "Confianza alta"
      },
      detailPoste: "Detalle por categoría",
      hypothesesGenerales: "Hipótesis generales",
      totalEstime: "Total estimado",
      justification: "Justificación",
      facturation: "Facturación y valorización",
      consultation: "Consulta",
      ghs: "GHS/Hospitalización",
      consultationItems: "Elementos de valorización",
      diagnosticPrincipal: "Diagnóstico principal (DP)",
      diagnosticsAssocies: "Diagnósticos asociados (DR)",
      composants: "Componentes de valorización",
      dureeSejour: "Duración de estancia",
      present: "Presente",
      absent: "Ausente",
      commentairesOptimisation: "Comentarios de optimización"
    },
    messages: {
      invalidInput: "Por favor ingrese una descripción clínica",
      success: "Códigos generados exitosamente",
      noSuggestions: "No se encontraron códigos para esta descripción",
      error: "Error al generar códigos",
      serverError: "Error del servidor",
      codesFound: "{{count}} códigos sugeridos",
      fromCache: "desde caché",
      unknownError: "Error desconocido",
    },
    feedback: {
      question: "¿Son útiles estos resultados?",
      positive: "¡Gracias por su comentario positivo!",
      negative: "Gracias, estamos mejorando nuestras sugerencias.",
    },
    export: {
      title: "Resultados de codificación médica",
      copied: "Resultados copiados al portapapeles",
      copyError: "Error al copiar resultados",
    },
    errors: {
      title: "Error de generación"
    },
    skeleton: {
      analyzeContext: 'Análisis del contexto clínico',
      generateCCAM: 'Generación de códigos CCAM',
      generateCIM10: 'Generación de códigos CIM-10',
      calculateBilling: 'Cálculo de facturación y valorización',
      generating: 'Generando…',
      inProgress: 'En curso…',
    },
    time: {
      justNow: "Ahora mismo",
      minutesAgo: "Hace {{count}} min",
      hoursAgo: "Hace {{count}}h",
      daysAgo: "Hace {{count}} día(s)",
    },
    dateGroups: {
      today: "Hoy",
      yesterday: "Ayer",
      thisWeek: "Esta semana",
      older: "Más antiguo",
    },
    enhanced: {
      replayFromHistory: "Repetir desde historial",
      aiDisclaimer: "Los códigos CCAM son generados por inteligencia artificial y deben verificarse en el repositorio oficial ATIH/HAS antes de cualquier uso de facturación.",
      clearFilter: "Borrar filtro",
      resetFilters: "Restablecer filtros",
    },
    examples: {
      appendectomy: "Apendicectomía laparoscópica",
      diabetesFollowup: "Seguimiento diabetes tipo 2 con complicaciones",
      hipFracture: "Fractura de cadera, paciente anciano",
      centralCatheter: "Colocación de catéter venoso central",
      cesarean: "Cesárea programada",
      endoscopy: "Endoscopia digestiva alta diagnóstica",
    },
  }
};